module.exports = __webpack_public_path__ + "static/img/3.cb614bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/3.png
// module id = dxN+
// module chunks = 0